import { titleUI } from 'platform/forms-system/src/js/web-component-patterns';
import { apportionmentInformationText } from '../../definitions/constants';

export default {
  path: 'reasons-for-apportionment-claim',
  title: apportionmentInformationText.reasonsIntroPageTitle,
  uiSchema: {
    ...titleUI(
      apportionmentInformationText.reasonsIntroPageTitle,
      apportionmentInformationText.reasonsIntroDescription,
    ),
  },
  schema: {
    type: 'object',
    properties: {},
  },
};
